<template>
  <el-dialog :close-on-click-modal="false" v-dialogDrag :title="currencyPhoneCodeTitle" append-to-body @close='closeDialog'
             v-if="currencyPhoneCodeDialogVisible" :visible.sync="currencyPhoneCodeDialogVisible" width="30%">
    <el-row>
      <el-alert title="请输入手机号" :closable="false" v-if="!EchoedPhone" type="warning" show-icon></el-alert>
      <!-- 父组件传过来手机号回显 -->
      <el-form ref="phone" style="padding-top: 1vh;padding-bottom:3em;" :rules="rules" :model="phone" label-suffix="："
               label-width="120px">
        <el-form-item v-if="EchoedPhone" label="手机号">
          {{phone.mobilePhone}}
        </el-form-item>
        <!-- 自己输入手机号时 -->
        <el-row>
          <el-col :span="16">
            <el-form-item v-if="!EchoedPhone" label="手机号" prop="mobilePhone">
              <el-input v-model="phone.mobilePhone" autocomplete="off" maxlength="11"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row style="display: flex; align-items: center;">
          <!-- 短信验证码表单 -->
          <el-col :span="16">
            <el-form-item label="短信验证码" prop="messageVerificationCode">
              <el-input v-model.number="phone.messageVerificationCode" oninput="value=value.replace(/^\.+|[^\d.]/g,'')"
                        id="code" autocomplete="off" maxlength="6"></el-input>
            </el-form-item>
          </el-col>
          <!-- 发送短信按钮 -->
          <el-col :span="6" :offset="1">
            <el-button :disabled="!show" style="margin-bottom: 22px;" type="success"
                       @click="sendMessageVerificationCode">
              <span v-show="show">获取验证码</span>
              <span v-show="!show" class="count">重新发送 ({{count}}s)</span>
            </el-button>
          </el-col>
        </el-row>
        <!-- 底部footer -->
        <el-row style="bottom: 10px;position: absolute;right: 0;">
          <el-button type="primary" @click="submitForm('phone')">确定</el-button>
          <el-button @click="closeDialog">取消</el-button>
        </el-row>

      </el-form>
    </el-row>
  </el-dialog>
</template>

<script>
  import {isSimpleMobilePhone, validCodeLength} from '@/utils/validate'

  export default {
    name: "index",
    data() {
      //验证新手机号与旧手机号是否相同
      let newOldMobilePhone = (rule, value, callback) => {
        if (this.oldMobilePhone == this.phone.mobilePhone) {
          callback(new Error('新手机号与旧手机号不能相同'));
        } else {
          callback();
        }
      };
      return {
        currencyPhoneCodeTitle: '',//弹窗标题，需父组件传入
        currencyPhoneCodeDialogVisible: false,//控制弹窗是否显示
        //表单校验
        rules: {
          mobilePhone: [
            {required: true, message: '手机号不能为空', trigger: 'blur'},
            {validator: isSimpleMobilePhone, message: '手机号格式不正确', trigger: 'blur'},
            {validator: newOldMobilePhone, message: '新手机号与旧手机号不能相同', trigger: 'blur'}
          ],
          messageVerificationCode: [
            {required: true, message: '短信验证码不能为空', trigger: 'blur'},
            {type: 'number', message: '短信验证码为数字类型', trigger: 'blur'},
            {validator: validCodeLength, message: '短信验证码为六位数字', trigger: 'blur'},
          ],
        },
        //验证手机号的对象
        phone: {
          mobilePhone: undefined,    //手机号
          verificationType: undefined,    //验证类型
          messageVerificationCode: undefined   //验证码
        },//手机对象
        EchoedPhone: true,//是否是父组件传过来的手机号
        oldMobilePhone: undefined,//旧手机号，非必传
        show: true,
        count: "", // 初始化次数
        timer: null,
      }
    },
    mounted() {
      this.eventBus.$on('currencyPhoneCode', (params) => {
        this.onPhoneEvent(params)
      });

      // 个人中心-修改手机号触发
      this.eventBus.$on('currencyPhoneCode_user', (params) => {
        this.onPhoneEvent(params)
      })

    },
    beforeDestroy() {
      this.eventBus.$off('currencyPhoneCode');
      this.eventBus.$off('currencyPhoneCode_user')
    },
    methods: {
      // on监听事件的具体逻辑
      onPhoneEvent(params) {
        this.currencyPhoneCodeTitle = params.phoneTitle;
        this.phone.verificationType = params.verificationType;
        if (params.mobilePhone != undefined) {
          //证明传过来手机号了
          this.phone.mobilePhone = params.mobilePhone;
          this.oldMobilePhone = undefined;
          this.EchoedPhone = true;
        } else {
          //证明没传过来手机号
          this.EchoedPhone = false;
        }
        //判断是否有旧手机号，如果有，则是修改手机号
        if (params.oldMobilePhone != undefined) {
          this.oldMobilePhone = params.oldMobilePhone
        }
        //显示弹窗
        this.currencyPhoneCodeDialogVisible = true;
      },
      //关闭弹窗
      closeDialog(pass) {
        //重置数据
        this.resertData();
        this.currencyPhoneCodeDialogVisible = false;
        if(pass !== true && this.currencyPhoneCodeTitle=='身份验证') {
          window.location.href = "/static/login.html";
        }
      },
      //提交验证，验证短信验证码是否正确
      submitForm(phone) {
        this.$refs[phone].validate((valid) => {
          if (valid) {
            //后台验证验证码是否正确
            this.common.httpPost('校验短信验证码', '/admin/basic/verificationCode/verifyPhoneCode', this.phone).then((res) => {
              if (res != undefined) {
                //验证通过,通知父组件，区分是旧手机号还是新手机号
                if (this.EchoedPhone) {
                  //重置数据
                  this.resertData()
                  this.$emit('oldValidPass');
                } else {
                  //将新手机号返回给父组件
                  this.$emit('newValidPass', this.phone.mobilePhone);
                  //每一个新手机号验证通过，都关闭弹窗
                  this.closeDialog(true);
                }
              } else {
                console.log('验证失败')
              }
            })
          } else {
            return false
          }
        })
      },
      //重置数据
      resertData() {
        this.phone.mobilePhone = undefined,
          this.phone.messageVerificationCode = undefined,
          this.EchoedPhone = true;
        this.oldMobilePhone = undefined;
        //销毁计时器
        clearInterval(this.timer); // 清除定时器
        this.timer = null;
        this.count = ''
        this.show = true
        //通知父组件重置数据
        this.$emit('resertData');
      },
      //验证手机号发送验证码
      sendMessageVerificationCode() {
        //判断手机号是否为空，为空则不能发验证码
        if (this.phone.mobilePhone == undefined) {
          //this.$message.error('手机号不能为空');
           this.$refs['phone'].validateField('mobilePhone')
          return;
        } else {
          //手机号格式
          const reg = /^1[0-9]{10}$/;
          if (!reg.test(this.phone.mobilePhone)) {
            // this.$message.error('手机号格式不正确');
            return;
          }
          //如果传过来的手机号为空，并且传过来的旧手机号不为空，则是修改新手机号
          if (this.phone.mobilePhone == this.oldMobilePhone) {
            this.$message.error('新手机号与旧手机号不能相同');
            return;
          }
        }
        this.common.httpPost("获取短信验证码", "admin/basic/verificationCode/getPhoneCode", {
          verificationType: this.phone.verificationType,
          mobilePhone: this.phone.mobilePhone
        }).then(res => {
          if (res != undefined) {
            //发送验证码成功，验证码输入框获取焦点
            document.getElementById('code').focus();
            //进入倒计时
            this.countDown();
          }
        });
      },
      //倒计时
      countDown() {
        const TIME_COUNT = 120; //更改倒计时时间
        if (!this.timer) {
          this.count = TIME_COUNT;
          this.show = false;
          this.timer = setInterval(() => {
            if (this.count > 0 && this.count <= TIME_COUNT) {
              this.count--;
            } else {
              this.show = true;
              clearInterval(this.timer); // 清除定时器
              this.timer = null;
            }
          }, 1000);
        }
      }
    },
  }
</script>


<style scoped>
  .el-form {
    height: 10em;
  }
</style>



// WEBPACK FOOTER //
// src/components/PhoneVerificationCode/currencyPhoneCode.vue